import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { SubAreaModel } from "./subAreaModel"
import { PriceCutModel } from "./priceCutModel"
import { StringUtil } from "@/core/utils/string_util"

@Serializable
export class SupplierSubAreaModel extends SubAreaModel {
  parentId: string = ""
  selected: boolean = true
  supplierId: string = ""
  supplierName: string = ""
  supplierPriceCut: PriceCutModel | null = null

  constructor(data?: Partial<SupplierSubAreaModel> | null) {
    super(data)
    if (data) {
      if (data.supplierPriceCut) {
        this.supplierPriceCut = new PriceCutModel(data.supplierPriceCut)
      }
      Object.assign(this, data)
    }
  }
}
